@if (form) {
    <div class="sir-form-button-container" [formGroup]="form">
        <button siriusButton [buttonText]="'Next'" [buttonType]="'primary'" type="submit"></button>
    </div>
}
